<div class="d-flex justify-content-between align-items-center mb-3">
  <h1 class="fs-5 fw-bold mb-0">News</h1>
  <div class="d-flex gap-2">
    <a [routerLink]="['add']" *isGranted="['ROLE_API_NEWS_WRITE']" class="btn btn-primary fw-bold">
      <i class="bi bi-plus-lg me-2"></i>Add News
    </a>
  </div>
</div>

<div class="card border-0 shadow mb-3 fade-in-zoom">
  <div class="card-body">
    <div class="table-responsive">
      <table class="table table-hover table-striped align-middle">
        <thead>
          <tr [tableSorter]="tableSorter" (tableSorterChange)="fetchAll()">
            <th>Image</th>
            <th tableSorterHeader="id">ID</th>
            <th tableSorterHeader="title">Title</th>
            <th tableSorterHeader="excerpt">Excerpt</th>
            <th tableSorterHeader="publishedAt">Publication date</th>
            <th class="text-center">Action</th>
          </tr>
        </thead>
        <tbody>
          @for (singleNews of news; track singleNews) {
            <tr>
              <td>
                <div class="news-image">
                  @if (singleNews.image) {
                    <img [ngSrc]="imageService.getImageUrl(singleNews.image, 30, 30)" width="30" height="30" class="rounded" alt="News image">
                  }
                </div>
              </td>
              <td>{{ singleNews.id }}</td>
              <td>{{ singleNews.title }}</td>
              <td>{{ singleNews.excerpt }}</td>
              <td>{{ singleNews.publishedAt | date: 'dd/MM/yyy' }} at {{ singleNews.publishedAt | date: 'HH:mm' }}</td>
              <td class="text-center">
                <a class="btn btn-outline-primary btn-sm" [routerLink]="[singleNews.id]">
                  <i class="bi bi-pencil me-1"></i>Edit
                </a>
                <button *isGranted="['ROLE_API_NEWS_WRITE']" class="btn btn-outline-danger btn-sm ms-1" appConfirm (click)="delete(singleNews)">
                  <i class="bi bi-trash"></i>
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>

      <app-paginator (pageChange)="fetchAll()" [paginator]="paginator"></app-paginator>
    </div>
  </div>
</div>
